<template>
    <div class="refresh-line-container">
        <div class="refresh-line">
            <v-btn small class="refresh-btn" @click="refresh()"><i class="fas fa-redo" /> &nbsp;&nbsp; Refresh</v-btn>
            <v-btn v-if="trialId" small class="update-btn" @click="calculateMean()"><i class="fas fa-calculator" /> &nbsp;&nbsp; Update Mean</v-btn>
        </div>
        <div v-if="updatedDate" class="refresh-line mt-2 s">
            <span class="small-text">Last Update Mean Date: {{ updatedDate }}</span>
        </div>
    </div>
</template>

<script>
export default {
    props: ["trialId","updatedDate"],
    methods: {
        calculateMean() {
            var self = this;
            axios({
                method: "POST",
                url: "CalculatedData/RepopulateEverything",
                data: {
                    trialId: self.trialId
                }
            })
                .then(function (response) {
                    self.$emit("refresh-get-mean");
                    EventBus.$emit("snackBar", {
					    text: "Update of mean is initiated, please wait for a while",
					    snackbarColor: "blue"
                    });
                });
        },
        refresh() {
            this.$emit("refresh-get-mean");
        }
    },
};
</script>

<style lang="css" scoped>
    .refresh-line-container{
        padding: 1rem 1.5rem 0 1.5rem;
    }
    .refresh-line{
        display: flex;
        justify-content: flex-end;
    }
    .small-text{
        font-size: 12px;
    }
    .update-btn, .refresh-btn{
        color: #333;
        display: inline-block;
        margin-right: 0;
    }
</style>


// WEBPACK FOOTER //
// src/smallComponents/DetailSummaryRefreshLine.vue